import AiImageBadge from "@/Components/ImageLibrary/AiImageBadge";
import IconButton from "@/Components/IconButton/IconButton";
import { isAiImage } from "@/shared/imageLibrary/aiImage";
import { useEffect, useState } from "react";
import NoIMG from "../../App/Assets/Images/empty.png";

interface FileProps {
  onChange?: (data: any, hasError: boolean) => void;
  size?: any;
  src?: string;
  isDeletable?: boolean;
  onClickDelete?: () => void;
  canUpload?: boolean;
  hideOnError?: boolean;
  /** Replaces the native file picker, e.g. to open an image picker modal. */
  onClick?: () => void;
  ariaLabel?: string;
}

const File = ({
  onChange,
  src,
  size = "10rem",
  isDeletable,
  onClickDelete,
  canUpload = true,
  hideOnError = false,
  onClick,
  ariaLabel,
}: FileProps) => {
  const [image, setImage] = useState(src);
  const [hasError, setHasError] = useState(false);
  const hideImage = hideOnError && hasError;

  const handleError = (event) => {
    setHasError(true);
    event.target.src = NoIMG;
  };

  const onImage = (e) => {
    onChange?.(e.target.files, hasError);
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImage(reader.result.toString()); // Stel de afbeelding-URL in.
      };
      reader.readAsDataURL(file); // Lees de afbeelding als een data-URL.
    }
  };

  useEffect(() => {
    setImage(src);
  }, [src]);

  if (hideImage) {
    return null;
  }

  return (
    <span className="inline-block relative">
      {onClick && canUpload ? (
        <button
          type="button"
          aria-label={ariaLabel}
          title={ariaLabel}
          onClick={(e) => {
            e.stopPropagation();
            onClick();
          }}
          className="absolute inset-0 z-1 cursor-pointer rounded-[0.5rem] border-none bg-transparent p-0 transition-shadow hover:shadow-[0_0_0_0.2rem_var(--primary)] focus-visible:outline-none focus-visible:shadow-[0_0_0_0.3rem_var(--primary)]"
        />
      ) : (
        <input
          onChange={onImage}
          onClick={(e) => e.stopPropagation()}
          type={canUpload ? "file" : ""}
          accept=".png, .jpg, .jpeg"
          className="opacity-[0] cursor-pointer w-full h-full absolute"
        />
      )}
      <img
        alt="Image"
        src={image || NoIMG}
        onError={handleError}
        className="rounded-[0.5rem] object-cover"
        style={{ width: size, height: size }}
      />
      {/* Not on a locally picked file, which is shown as a data url. */}
      {image === src && isAiImage(src) && !hasError && <AiImageBadge />}
      {isDeletable && src && !hasError && (
        <div className="absolute top-[-1rem] -right-6">
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              onClickDelete();
            }}
            type="button"
            variants="trash"
            variant="danger"
            size="small"
          />
        </div>
      )}
    </span>
  );
};

export default File;
